'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';

import { usePathname } from 'next/navigation';

const SubNavContext = createContext(null);

/**
 * Provides shared desktop subnav state:
 *  - which top-level item is open
 *  - which sub-group panel is open
 * Resets on route changes.
 */
export const SubNavProvider = ({ onActiveHoverChange, children }) => {
    const [activeHoverIndex, setActiveHoverIndex] = useState(-1);
    const [activeSubGroupIndex, setActiveSubGroupIndex] = useState(-1);

    const pathname = usePathname();

    // Reset on navigation
    useEffect(() => {
        setActiveHoverIndex(-1);
        setActiveSubGroupIndex(-1);
    }, [pathname]);

    const setActiveIndex = useCallback(
        index => {
            setActiveHoverIndex(prev => {
                // Only reset the sub-group when switching to a
                // different nav item, not when re-focusing the same one.
                if (prev !== index) {
                    setActiveSubGroupIndex(-1);
                }
                return index;
            });
            onActiveHoverChange?.(index);
        },
        [onActiveHoverChange]
    );

    return (
        <SubNavContext.Provider
            value={{
                activeHoverIndex,
                activeSubGroupIndex,
                setActiveIndex,
                setActiveSubGroupIndex,
            }}
        >
            {children}
        </SubNavContext.Provider>
    );
};

export const useSubNav = () => {
    return useContext(SubNavContext);
};
